var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { FontStyle } from '@inter-ikea-kompis/themes';
class Text extends KompisElement {
    constructor() {
        super(...arguments);
        // What type of text it is. e.g. bodyMedium, bodyLarge, bodyXLarge
        this.type = ThemeFontStyleTypeEnum.bodyMedium;
        // Activate italic style
        this.italic = false;
        // Activate bold style
        this.bold = false;
        // Activate underline style
        this.underline = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        if (!this.theme) {
            return html `<slot></slot>`;
        }
        return html `
			<style>
				slot, ::slotted(*) {
					text-decoration: inherit;
					color: inherit;
				}
				:host {
					display: inline;
					color: inherit;
				}
				${FontStyle.getStyle({
            type: this.type,
            italic: this.italic,
            bold: this.bold,
            underline: this.underline,
            theme: this.theme
        })}
			</style>
			<slot></slot>
		`;
    }
}
// A flag preventing the stylesheet to be added more than once
Text.hasAddedStylesheet = false;
export default Text;
__decorate([
    property({ type: String })
], Text.prototype, "type", void 0);
__decorate([
    property({ type: Boolean })
], Text.prototype, "italic", void 0);
__decorate([
    property({ type: Boolean })
], Text.prototype, "bold", void 0);
__decorate([
    property({ type: Boolean })
], Text.prototype, "underline", void 0);
__decorate([
    property({ type: Object, required: true })
], Text.prototype, "theme", void 0);
//# sourceMappingURL=Text.js.map